import Vue from 'vue'

Vue.filter('os', (value) => {
    if (value === 'mac') {
        return 'MacOS'
    }
    return value
})